import type { ButtonProps as ButtonAntProps } from 'antd';
import { css, type DefaultTheme, type FlattenInterpolation, type ThemeProps } from 'styled-components';

export const getActionsButtonStyleByType = (
  type: ButtonAntProps['type'],
): FlattenInterpolation<ThemeProps<DefaultTheme>> => {
  switch (type) {
    case 'primary':
      return css`
        color: ${({ theme }) => theme.color.grey.white};
        background-color: ${({ theme }) => theme.color.theme.primary};
        border-style: none;

        &:hover {
          background-color: ${({ theme }) => theme.color.theme.light};
        }

        &:focus-visible {
          outline-color: ${({ theme }) => theme.color.separators.divider};
          outline-offset: -2px;
        }

        &:active {
          background-color: ${({ theme }) => theme.color.theme.tertiary};
        }

        &:disabled {
          background-color: ${({ theme }) => theme.color.grey.grey4};
          color: ${({ theme }) => theme.color.type.disabled};
          border-style: none;
        }

        &.ant-btn-dangerous {
          background-color: ${({ theme }) => theme.color.status.error};
          color: ${({ theme }) => theme.color.grey.white};
          border-style: none;
          text-decoration: none;

          &:hover {
            background-color: ${({ theme }) => theme.color.semantic.feedback.background.error} !important;
          }
        }
      `;
    case 'text':
      return css`
        color: ${({ theme }) => theme.color.theme.primary};
        background-color: transparent;
        border-style: none;
        text-decoration: underline 0.5px;
        text-underline-offset: 1.5px;

        &:hover {
          background-color: ${({ theme }) => theme.color.theme.lighterAlt} !important;
          text-decoration: underline 0.5px;
        }

        &:focus-visible {
          color: ${({ theme }) => theme.color.theme.primary};
          outline-color: ${({ theme }) => theme.color.theme.darkAlt};
        }

        &:active {
          background-color: ${({ theme }) => theme.color.theme.lighter};
        }

        &:disabled {
          background-color: ${({ theme }) => theme.color.grey.grey4};
          color: ${({ theme }) => theme.color.type.disabled};
          border-style: none;
          text-decoration: none;
        }

        &.ant-btn-dangerous {
          color: ${({ theme }) => theme.color.status.error};
          background-color: ${({ theme }) => theme.color.grey.white};
          border-style: none;
          text-decoration: none;

          &:hover {
            background-color: ${({ theme }) => theme.color.semantic.feedback.background.error} !important;
          }
        }
      `;
    case 'default':
    default:
      return css`
        color: ${({ theme }) => theme.color.theme.primary};
        background-color: ${({ theme }) => theme.color.grey.white};
        border: 1px solid ${({ theme }) => theme.color.theme.primary};

        &:hover {
          background-color: ${({ theme }) => theme.color.semantic.primary.background.hoverWeak} !important;
        }

        &:focus-visible {
          outline-color: ${({ theme }) => theme.color.theme.darkAlt};
          outline-offset: -3px;
        }

        &:active {
          background-color: ${({ theme }) => theme.color.theme.lighter};
        }

        &:disabled {
          background-color: ${({ theme }) => theme.color.grey.grey4};
          color: ${({ theme }) => theme.color.type.disabled};
          border-style: none;
        }

        &.ant-btn-dangerous {
          color: ${({ theme }) => theme.color.status.error};
          background-color: ${({ theme }) => theme.color.grey.white} !important;
          border: 1px solid ${({ theme }) => theme.color.status.error};

          &:hover {
            background-color: ${({ theme }) => theme.color.semantic.feedback.background.error} !important;
          }
        }
      `;
  }
};
